import { ID } from '../../types/id'
export interface Units {
  rspo: number
  name: string
  voivodeship: string
  postcode: string
  city: string
  address: string
  publicUnit: boolean | null
}

export interface RSPO {
  rspo: number
}

export interface UnitsListProps extends Units {
  creationDate: string | null
  id: number | null
}

export type UserData = {
  unitId: ID
}

export type Users = {
  creationDate: string
  emailAddress: string
  firstName: string
  id: ID
  lastName: string
  login: string
  roleName: []
  roles: [
    {
      id: ID
      name: string
      permissions: []
    }
  ]
  unitId: ID
}

export type User = {
  unitId: ID
  userId: ID
  userLevel: number
}
//TODO its patient not diagnostic
export type Diagnostic = {
  disability: string
  id: ID
  person: {
    dateOfBirth: string
    email: string
    firstName: string
    gender: string
    id: ID
    lastName: string
    pesel: string
    phone: string
  }
  unitId: ID
  diagnosticianId: ID
  groupName: string
  creationDate: Date
}

export type ReadyProps = {
  patients: boolean
  users: boolean
}

export type ModalStruct = {
  isOpen: boolean | null
  isLogout: boolean
  redirect: string
}

export const voivodeships = [
  { value: 'DOSL', label: 'Dolnośląskie' },
  { value: 'KUJA', label: 'Kujawsko-Pomorskie' },
  { value: 'LUBE', label: 'Lubelskie' },
  { value: 'LUBU', label: 'Lubuskie' },
  { value: 'LODZ', label: 'Łódzkie' },
  { value: 'MALO', label: 'Małopolskie' },
  { value: 'MAZO', label: 'Mazowieckie' },
  { value: 'OPOL', label: 'Opolskie' },
  { value: 'PODK', label: 'Podkarpackie' },
  { value: 'PODL', label: 'Podlaskie' },
  { value: 'POMO', label: 'Pomorskie' },
  { value: 'SLSK', label: 'Śląskie' },
  { value: 'SWIE', label: 'Świętokrzyskie' },
  { value: 'WARM', label: 'Warmińsko-Mazurskie' },
  { value: 'WLKP', label: 'Wielkopolskie' },
  { value: 'ZACH', label: 'Zachodniopomorskie' },
]

export const unitTypes = [
  { value: true, label: 'Jednostka publiczna' },
  { value: false, label: 'Jednostka niepubliczna' },
]
